/**
 * Shared table styles for payment plan tables (Savings Plan, Payout Plan).
 * Replaces the dependency on the old TradeStep/PaymentPlanEditTable/styles.
 */
import { makeStyles } from "@material-ui/core";

import {
  baseTableCellStyles,
  baseTableFooterStyles,
  baseTableRowStyles,
  baseInputCellStyles,
  tableContainerStyles,
} from "./sharedTableStyles";

const paymentPlanTableStyles = (theme) => ({
  tableContainer: tableContainerStyles,
  tableCell: {
    ...baseTableCellStyles,
    '&.with-input': baseInputCellStyles,
  },
  tableFooter: {
    ...baseTableFooterStyles,
  },
  tableRow: {
    ...baseTableRowStyles,
  },
});

export const usePaymentPlanTableStyles = makeStyles(paymentPlanTableStyles);
